export default "__VITE_ASSET__D8qn7GRO__"